import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col } from 'reactstrap';
import { useForm, Controller } from "react-hook-form";
import ProcessDrawer from '../ProcessDrawer';
import {  SearchableSelectHookForm, TextFieldHookForm } from '../../layout/HookFormInputs'
import Button from '../../layout/Button';
import { getBopCategorySelectList, getBopNumberSelectList } from '../actions/rfq';
import {  RECEIVED } from "../../../config/constants";
import TooltipCustom from "../../common/Tooltip";
import { canEnableFields } from "../../../helper";

const RaiseRfqBopDetails = (props) => {
    
    const { setViewQuotationPart, updateBopList, updateButtonPartNoTable, dataProps, resetBopFields, plant, prNumber, disabledPartUid, resetDrawer, isPartDetailsDisabled } = props

    const [drawerOpen, setDrawerOpen] = useState(false);
    const { register, handleSubmit, setValue, getValues, formState: { errors }, control, clearErrors } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            radioOption: false, // Initialize default value for the radio button
        }
    });
    const dispatch = useDispatch()
    const { isEditFlag, isViewFlag ,isAddFlag} = props?.dataProps
    const { SelectBopNumber, SelectBopCategory } = useSelector((state) => state.rfq)
    const [bopNumber, setBopNumber] = useState([])
    const [bopName, setBopName] = useState("")
    const [bopCategory, setBopCategory] = useState([])
    const [bopAttchment, setBopAttchment] = useState([])
    const [bopRemark, setBopRemark] = useState("");
    const [bopSpecificationList, setBopSpecificationList] = useState([])
    const { bopSpecificRowData } = useSelector(state => state?.rfq);
    const { onBopNameChange = () => {} } = props;

    const areFieldsEnabled = canEnableFields({
        plant,
        type: 'BOP',
        updateButtonPartNoTable,
        isEditMode: isEditFlag,
        isViewMode: isViewFlag,
        isEditFlagReceived: isEditFlag && dataProps?.rowData?.Status === RECEIVED,
        showSendButton: dataProps?.rowData?.Status,
        isAddFlag: isAddFlag
    });


    useEffect(() => {
        dispatch(getBopNumberSelectList(() => { }))

    }, [])
  
    useEffect(() => {
        setBopData()
    }, [bopNumber, bopName, bopCategory, bopAttchment, bopRemark, bopSpecificationList])
    useEffect(() => {
        setValue('BOPName', bopName)
    }, [bopName])
    useEffect(() => {
        if (resetBopFields) {

            onResetBopFields()
        }
    }, [resetBopFields])

    useEffect(() => {
        onBopNameChange(!!bopNumber?.value);
    }, [bopNumber, onBopNameChange]);

    useEffect(() => {
        if (updateButtonPartNoTable) {

            let obj = {
                BoughtOutPartChildId: bopSpecificRowData[0]?.BoughtOutPartChildId,
                BoughtOutPartCategoryId: bopSpecificRowData[0]?.BoughtOutPartCategoryId,
                BoughtOutPartName: bopSpecificRowData[0]?.BoughtOutPartName,
                BoughtOutPartCategoryName: bopSpecificRowData[0]?.BoughtOutPartCategoryName,
                BoughtOutPartNumber: bopSpecificRowData[0]?.BoughtOutPartNumber,
                BopReamrk: bopSpecificRowData[0]?.Remarks,
                BopAttachments: bopSpecificRowData[0]?.Attachments,
                BopSpecification: bopSpecificRowData[0]?.PartSpecification

            }
            setBopAttchment(bopSpecificRowData[0]?.Attachments)
            setBopRemark(bopSpecificRowData[0]?.Remarks)
            setBopSpecificationList(bopSpecificRowData[0]?.PartSpecification)
            setValue('BOPNo', { label: bopSpecificRowData[0]?.BoughtOutPartNumber, value: bopSpecificRowData[0]?.BoughtOutPartChildId })
            setValue('Category', { label: bopSpecificRowData[0]?.BoughtOutPartCategoryName, value: bopSpecificRowData[0]?.BoughtOutPartCategoryId })
            setValue("BOPName", bopSpecificRowData[0]?.BoughtOutPartName)
            onBopNameChange(!!bopSpecificRowData[0]?.BoughtOutPartChildId);

            // Clear validation errors when form is populated with existing data
            clearErrors(['BOPNo', 'Category', 'BOPName']);

            updateBopList(obj)
        }
    }, [updateButtonPartNoTable, bopSpecificRowData, onBopNameChange])
    const onResetBopFields = () => {
        setBopCategory([]);
        setBopNumber([]);
        setBopName([]);
        setBopAttchment([]);
        setBopSpecificationList([]);
        setBopRemark("");
        setValue('BOPName', '')
        setValue('BOPNo', '')
        setValue('Category', '')

        // Clear all validation errors when resetting fields
        clearErrors(['BOPName', 'BOPNo', 'Category']);

        onBopNameChange(false);
        updateBopList && updateBopList({});
    }
    const DrawerToggle = () => {
        // if (CheckIsCostingDateSelected(CostingEffectiveDate)) return false;
        setDrawerOpen(true)
    }
    const closeDrawer = () => {
        setDrawerOpen(false);

    }
    const setBopData = () => {
        if (bopCategory?.length !== 0 && bopNumber?.length !== 0 && bopName?.length !== 0) {
            let obj = {
                BoughtOutPartChildId: bopNumber?.value,
                BoughtOutPartCategoryId: bopCategory?.value,
                BopAttachments: bopAttchment,
                BopReamrk: bopRemark,
                BopSpecification: bopSpecificationList,
                BoughtOutPartName: bopName,
                BoughtOutPartCategoryName: bopCategory?.label,
                BoughtOutPartNumber: bopNumber?.label,


            }

            updateBopList(obj)

        }
    }
    const renderListing = (label) => {
        const temp = []
        if (label === 'bopNumber') {
            SelectBopNumber && SelectBopNumber?.map((item) => {
                const match = item?.Text.match(/\(([^)]+)\)/);
                const valueInsideBrackets = match ? match[1] : '';
                if (item.Value === '0') return false
                temp.push({ label: valueInsideBrackets, value: item?.Value })
                return null
            })
            return temp
        }

        if (label === 'category') {
            SelectBopCategory && SelectBopCategory?.map((item) => {
                if (item.Value === '0') return false
                temp.push({ label: item.Text, value: item.Value })
                return null
            })
            return temp
        }


    }
    const handleBopNo = (newValue, actionMeta) => {

        if (newValue && newValue !== '') {

            // Clear validation errors when BOP No is selected
            clearErrors(['BOPNo', 'Category', 'BOPName']);

            setBopNumber({ label: newValue?.label, value: newValue?.value })
            const selectedBop = SelectBopNumber?.find(item => item?.Value === newValue?.value);
            const name = selectedBop?.Text?.split(' (')[0]?.trim();


            setBopName(name);
            dispatch(getBopCategorySelectList(newValue?.value, () => { }))
            setBopCategory([])
            setValue("Category", "")

        } else {
            setBopNumber([])
            //dispatch(getBopCategorySelectList(newValue?.value, () => { }))
            setBopCategory([])
            setBopName("")
            setValue("Category", "")
            onResetBopFields();
        }
    }
    const handleBopCategory = (newValue, actionMeta) => {
        if (newValue && newValue !== '') {
            // Clear validation errors when Category is selected
            clearErrors(['Category']);
            setBopCategory({ label: newValue?.label, value: newValue?.value })
        } else {
            setBopCategory([])
            setValue('Category', '')
        }
    }

    return (
        <div className='bop-details-wrapper'>
            {/* <HeaderTitle title={'BOP:'} /> */}
            {props.heading()}
            <Row className="part-detail-wrapper">
                <Col md="3">
                    <SearchableSelectHookForm
                        label="BOP No."
                        name={"BOPNo"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{ required: true }}
                        options={renderListing("bopNumber")}
                        mandatory={true}
                        handleChange={handleBopNo}
                        disabled={!areFieldsEnabled || isPartDetailsDisabled}
                        className="fullinput-icon"
                        errors={errors.BOPNo}
                        isClearable={true}
                    />
                </Col>

                <Col md="3" >
                    <TextFieldHookForm
                        label="BOP Name"
                        name={"BOPName"}
                        Controller={Controller}
                        control={control}
                        register={register}
                        mandatory={false}
                        rules={{
                            required: false,
                        }}
                        handleChange={(e) => {
                            const value = e.target.value;
                            setBopName(value);
                        }}
                        defaultValue={""}
                        className=""
                        disabled={!areFieldsEnabled || isPartDetailsDisabled}
                        customClassName={"withBorder"}
                        errors={errors.MBName}
                    />
                </Col>

                <Col md="3">
                    <div className='d-flex align-items-center'>
                        <SearchableSelectHookForm
                            label="Category"
                            name={"Category"}
                            placeholder={"Select"}
                            Controller={Controller}
                            control={control}
                            rules={{ required: true }}
                            options={bopNumber?.value ? renderListing("category") : []}
                            mandatory={true}
                            handleChange={handleBopCategory}
                            className="fullinput-icon"
                            disabled={!areFieldsEnabled || isPartDetailsDisabled}
                            errors={errors.Category}
                            isClearable={true}
                        />
                        <TooltipCustom id="addBOPSpecification" disabledIcon={true} tooltipText="Click on the + button to start inputting Specification and mandatory attachments." />
                        <Button id="addBOPSpecification" className={"ml-2 mb-2 "}
                            variant={updateButtonPartNoTable ? 'Edit' : 'plus-icon-square'}
                            title={updateButtonPartNoTable ? 'Edit' : 'Add'} onClick={DrawerToggle}
                            disabled={!areFieldsEnabled || isPartDetailsDisabled}
                        >
                        </Button>

                    </div>

                </Col>


            </Row>

            <div className=''>
                {
                    drawerOpen &&
                    (
                        <ProcessDrawer
                            isOpen={drawerOpen}
                            anchor={"right"}
                            closeDrawer={closeDrawer}
                            partType={'Bought Out Part'}
                            setViewQuotationPart={setViewQuotationPart}
                            specificationList={bopSpecificationList}
                            setSpecificationList={setBopSpecificationList}
                            setRemark={setBopRemark}
                            remark={bopRemark}
                            isEditFlag={isEditFlag}
                            isViewFlag={isViewFlag}
                            setChildPartFiles={setBopAttchment}
                            childPartFiles={bopAttchment}
                            bopNumber={bopNumber}
                            resetDrawer={resetDrawer}
                        />
                    )
                }
            </div>
        </div>

    )
}

export default RaiseRfqBopDetails;
